import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { SecureSessionService } from './secure-session.service';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  schoolId: any;
  sessionData: any;
  //  private _loginUrl="Login/login";
  private _loginUrl = 'Login/login/v2';
  private _resetPasswordUrl = 'Login/reset-password';
  constructor(
    private http: HttpClient,
    private _config: ConfigService,
    private session: SecureSessionService
  ) {
    // this.sessionData=JSON.parse(this.session.getSession());
    // this.schoolId=this.sessionData[0].schoolId;
  }
  login(loginData: any): Observable<any> {
    return this.http
      .post<any>(this._config._url + this._loginUrl, loginData)
      .pipe(catchError(this.handleError));
  }
  //  reset(resetData: any): Observable<any> {
  //   return this.http.post<any>(this._config._url + this._resetPasswordUrl, resetData, {
  //   responseType: 'text'
  // }).pipe(
  //     catchError(this.handleError)
  //   );
  // }
  reset(resetData: any): Observable<string> {
    return this.http
      .post<string>(this._config._url + this._resetPasswordUrl, resetData, {
        responseType: 'text' as 'json', // 👈 This is the key trick
      })
      .pipe(catchError(this.handleError));
  }

  forgotPassword(email: string): Observable<any> {
    const payload = { email };
    return this.http
      .post(`${this._config._url}Login/resend-credentials`, payload)
      .pipe(catchError(this.handleError));
  }

  resendCredentialsBySms(phoneNumber: string): Observable<any> {
    const payload = { phoneNumber };
    return this.http
      .post(`${this._config._url}Login/resend-credentials-sms`, payload)
      .pipe(catchError(this.handleError));
  }

  resendCredentialsByWhatsapp(phoneNumber: string): Observable<any> {
    const payload = { phoneNumber };
    return this.http
      .post(`${this._config._url}Login/resend-credentials-whatsapp`, payload)
      .pipe(catchError(this.handleError));
  }

   resendCredentialsBySmsStaff(phoneNumber: string): Observable<any> {
    const payload = { phoneNumber };
    return this.http
      .post(`${this._config._url}Login/user/resend-credentials-sms`, payload)
      .pipe(catchError(this.handleError));
  }

resendCredentialsByWhatsappStaff(phoneNumber: string): Observable<any> {
    const payload = { phoneNumber };
    return this.http
      .post(`${this._config._url}Login/user/resend-credentials-whatsapp`, payload)
      .pipe(catchError(this.handleError));
  }

  resendUserCredentials(email: string): Observable<any> {
    const payload = { email };
    return this.http
      .post(`${this._config._url}Login/resend-user-credentials`, payload)
      .pipe(catchError(this.handleError));
  }
  //   let validationMessages: string[] = [];

  //   console.error('Full error response:', error);

  //   // Client-side error
  //   if (error.error instanceof ErrorEvent) {
  //     errorMessage = `Client-side error: ${error.error.message}`;
  //   } else {
  //     // 409 Conflict
  //     if (error.status === 409) {
  //       errorMessage = `Conflict: ${error.error?.message || error.error?.errormessage || 'Unknown conflict error'}`;
  //     }

  //     // 400 Bad Request - Validation or Custom Message with Errors Array
  //     else if (error.status === 400) {
  //       const err = error.error;

  //       // Case: `errors` is an object (field-based validation)
  //       if (err?.errors && typeof err.errors === 'object' && !Array.isArray(err.errors)) {
  //         for (const field in err.errors) {
  //           if (err.errors.hasOwnProperty(field)) {
  //             validationMessages.push(`${field}: ${err.errors[field].join(', ')}`);
  //           }
  //         }
  //       }

  //       // Case: `errors` is an array (like division not found at row 2)
  //       else if (Array.isArray(err?.errors)) {
  //         validationMessages = err.errors;
  //       }
  //       else if (err?.errors && err?.message) {
  //         validationMessages.push(err.errors);
  //       }

  //       // Combine message with any validation errors
  //       errorMessage = err.errors || 'Validation failed';
  //       if (validationMessages.length) {
  //         errorMessage += ` | ${validationMessages.join(' | ')}`;
  //       }
  //     }

  //     // 404 Not Found
  //     else if (error.status === 404) {
  //       errorMessage = `Not Found: ${error.error?.message || 'Resource not found'}`;
  //     }

  //     // Other server-side error
  //     else {
  //       errorMessage = error.error?.message || `Server Error (Status ${error.status})`;
  //     }
  //   }

  //   console.error('Processed error message:', errorMessage);

  //   // Return the error as observable
  //   return throwError(() => new Error(errorMessage));
  // }
  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    let validationMessages: string[] = [];

    console.error('Full error response:', error);

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // 🔁 If error.error is a string (because of 'text' responseType), parse it
      let parsedError: any = {};

      if (typeof error.error === 'string') {
        try {
          parsedError = JSON.parse(error.error);
        } catch (e) {
          parsedError = { message: error.error }; // fallback if parsing fails
        }
      } else {
        parsedError = error.error;
      }

      // Now proceed using parsedError
      if (error.status === 409 && parsedError) {
        errorMessage = ` ${
          parsedError.message ||
          parsedError.errormessage ||
          'Unknown conflict error'
        }`;
      } else if (error.status === 400 && parsedError) {
        if (parsedError.errors) {
          for (const field in parsedError.errors) {
            if (parsedError.errors.hasOwnProperty(field)) {
              validationMessages.push(
                `${field}: ${parsedError.errors[field].join(', ')}`
              );
            }
          }
        } else {
          validationMessages.push(
            parsedError.message || 'Unknown validation error'
          );
        }

        errorMessage =
          validationMessages.join(' | ') || 'Unknown validation error';
      } else if (error.status === 404) {
        errorMessage = `Not Found: ${
          parsedError.message || 'Resource not found'
        }`;
      } else {
        errorMessage = parsedError.message || 'Server error occurred';
      }
    }

    console.error('Processed error message:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
